/**
 * 公共接口
 */

const prefix = '/dseWeb'
export default [
  // 分页查询投诉建议记录
  { name: 'getSuggestRecords', url: `${prefix}/v1/op/suggestRecords`, method: 'get' }
]
